import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

type Props = {
    some?: string;
};

const LinkedInLogo: React.FC<Props & React.SVGProps<SVGSVGElement>> = ({ ...props }: Props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 18 18">
            <path
                d="M16.2 0H1.8C0.81 0 0 0.81 0 1.8V16.2C0 17.19 0.81 18 1.8 18H16.2C17.19 18 18 17.19 18 16.2V1.8C18 0.81 17.19 0 16.2 0ZM5.4 15.3H2.7V7.2H5.4V15.3ZM4.05 5.67C3.15 5.67 2.43 4.95 2.43 4.05C2.43 3.15 3.15 2.43 4.05 2.43C4.95 2.43 5.67 3.15 5.67 4.05C5.67 4.95 4.95 5.67 4.05 5.67ZM15.3 15.3H12.6V10.53C12.6 9.81004 11.97 9.18 11.25 9.18C10.53 9.18 9.9 9.81004 9.9 10.53V15.3H7.2V7.2H9.9V8.28C10.35 7.56 11.34 7.02 12.15 7.02C13.86 7.02 15.3 8.46 15.3 10.17V15.3Z"
                fill="#96A2AC"
            />
        </SvgIcon>
    );
};

export default LinkedInLogo;
